import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AlertTriangle, MessageCircle, ArrowLeft } from 'lucide-react';

const LOGO_URL = "/images/logo-tuprima.png";
const WHATSAPP_SUPPORT = "573206313258";

export default function RegisterPage() {
  const openWhatsApp = () => {
    const message = encodeURIComponent(
      `Hola TuPrima 👋\n\nQuisiera información sobre la plataforma.`
    );
    window.open(`https://wa.me/${WHATSAPP_SUPPORT}?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-100 to-slate-200 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        {/* Logo */}
        <div className="text-center">
          <img 
            src={LOGO_URL} 
            alt="Tu Prima" 
            className="h-16 mx-auto mb-4"
          />
        </div>

        <Card className="border-amber-200">
          <CardContent className="p-8 text-center">
            <AlertTriangle className="w-16 h-16 mx-auto mb-6 text-amber-500" />
            
            <h1 className="text-2xl font-bold text-slate-800 mb-4">
              Registro Suspendido
            </h1>
            
            <p className="text-slate-600 mb-6">
              Lamentamos informarte que actualmente no estamos aceptando 
              nuevos registros mientras reorganizamos la plataforma.
            </p>

            <div className="bg-slate-100 rounded-xl p-4 mb-6">
              <p className="text-sm text-slate-600 mb-2">
                ¿Tienes alguna consulta? Contáctanos:
              </p>
              <p className="text-2xl font-bold text-emerald-600 font-mono">
                320 631 3258
              </p>
            </div>

            <div className="space-y-3">
              <Button 
                onClick={openWhatsApp}
                className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-full"
              >
                <MessageCircle className="w-4 h-4 mr-2" />
                Contactar por WhatsApp
              </Button>
              
              <Link to="/">
                <Button variant="outline" className="w-full rounded-full">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Volver al Inicio
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-slate-400">
          Volveremos más fuertes con licencias oficiales y mejor estrategia.
        </p>
      </div>
    </div>
  );
}
